import { AudiencePageTemplate } from '@/components/AudiencePageTemplate'
import { getAudienceSegment } from '@/data/whoWeServe'

export default function MusicSchoolsPage() {
  return <AudiencePageTemplate segment={getAudienceSegment('music-schools')} />
}
